const escapeCsvValue = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  const stringValue = String(value);
  if (/[",\n]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }

  return stringValue;
};

export const exportIssuesToCsv = (issues, processName = 'workflow-analyzer') => {
  const headers = [
    'Severity',
    'Error Code',
    'Category',
    'File',
    'Item',
    'Description',
    'Recommendation'
  ];

  const rows = issues.map((issue) => [
    issue.errorSeverity || '',
    issue.errorCode || '',
    issue.categoryLabel || '',
    issue.filePath || '',
    issue.item || '',
    issue.description || '',
    issue.recommendation || ''
  ]);

  const csvContent = [headers, ...rows]
    .map((row) => row.map(escapeCsvValue).join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${processName.replace(/\s+/g, '_').toLowerCase()}_issues.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
